var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"viewBox":_vm.viewBox,"xmlns":"http://www.w3.org/2000/svg"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }